/*
 * accordion
 */
const accordionToggle = function() {

	const accordion = $('.js-accordion');

	accordion.each(function() {
		const thisAccordion = $(this);
		const accordionHeader =  thisAccordion.find('.js-accordion__header');

		accordionHeader.click(function() {
			thisAccordion.toggleClass('is-show');
		});
	});
}


/**
 * 初期オープンが必要なアコーディオンの制御
 *
 * ・`.js-accordion--autoopen` を持つアコーディオンのみ対象。
 * ・data-accordion-open="true" が付与されている場合、
 *   ページ読み込み時に `.is-show` を付与して展開状態にする。
 *
 * ・汎用アコーディオン（accordionToggle）には影響しない。
 *   初期状態だけを制御する拡張レイヤーとして動作する。
 *
 * ・主な用途（現時点）：
 *   - 症例検索UIのキーワードアコーディオン
 *     （検索条件が指定されている場合に自動で開いておきたい）
 *
 * ・`.js-accordion--autoopen` を他のアコーディオンに付与すれば
 *   同じ拡張挙動を流用できる汎用設計。
 */
const initAccordionAutoOpen = function() {

	const accordions = $('.js-accordion.js-accordion--autoopen');

	accordions.each(function() {
		const acc = $(this);

		if (acc.data('accordion-open') === true) {
			acc.addClass('is-show');
		}
	});
};




/*
 * init
 */
accordionToggle();
initAccordionAutoOpen();
